import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from 'components/Layout'
import OrderList from './components/OrderList'
import { setFlowStepperStep } from 'components/Steps/thunk'
import { addContinueUrl } from 'components/Footer/thunk'
import { Loader } from 'components/Loader'
import { OrderLoader } from 'components/Loader/components/OrderLoader'
import { SS, postWindowMessage } from 'utils/common'
import { setModeApp } from 'store/root-slices'

const Orders = ({ match }) => {
	let {
		nextFlowStep,
		steps,
		wrapperUrl,
		isLoading,
		isOrdersLoading,
		ordersItems,
	} = useSelector(({ steps, root, orders }) => ({
		nextFlowStep: steps.nextFlowStep,
		steps: steps.steps,
		wrapperUrl: root.wrapperUrl,
		isLoading: steps.isLoading,
		isOrdersLoading: orders.isLoading,
		isReturnedItemNoteActive: orders.isReturnedItemNoteActive,
		ordersItems: orders.orders,
	}))
	const dispatch = useDispatch()

	useEffect(() => {
		if (wrapperUrl) postWindowMessage(wrapperUrl, match.path)
		dispatch(setFlowStepperStep('SELECT'))
		dispatch(setModeApp('modal'))
		SS.set('modeApp', 'modal')
	}, [])

	useEffect(() => {
		if (nextFlowStep) dispatch(addContinueUrl(nextFlowStep))
	}, [steps])

	return (
		<Layout>
			<Loader
				isActive={(isLoading || isOrdersLoading) && !ordersItems}
				animation={<OrderLoader quantity={20} />}
			/>
			<OrderList />
		</Layout>
	)
}

export default Orders
